<div id="root">
  <div class="fixed-background">
    <main>
      <div class="container">
        <div class="row h-100">
          <div class="col-10 col-md-7 mx-auto my-auto">

            <div class="row card auth-card">

              <div class="col-4 position-relative backgroungImage">
                <!-- <p class="text-white text"><b> MANAGE ORDERS AND SHIP THEM HASSLE FREE </b></p> -->
                <p class="text-white text" ><b>MANAGE ORDERS AND SHIP THEM HASSLE FREE</b></p>
              </div>

              <div class="form-side col-8">
                
                <div>
                  <img class="mb-4 imagemargin" src="/assets/logos/destination/logo.png" alt="company logo" id="logo-img">
                </div>

                <h2 class="mb-4 mt-4 text-center"><b>We can't seem to find the page <br> you are looking for.</b></h2>

                <button [routerLink]="adminRoot" class="btn btn-primary btn-lg btn-shadow mt-4 buttonmargin" type="submit">
                  Goto Dashboard
                </button>
              </div>

            </div>

          </div>
        </div>
      </div>
    </main>
  </div>
</div>